import { Box, Button, CardContent, LinearProgress } from '@mui/material';
import { FC, useEffect, useState } from 'react';
import { Card } from '../../card/card.style';
import {
  CloseDialogButton,
  Dialog,
  DialogContent,
  DialogContentWrapper,
  DialogTitle
} from '../../dialog/dialog.styles';
import { Hr, ToolbarSection } from '../image-library.styles';

export interface PreviewImageDialog {
  open: boolean;
  url: string;
  onClose: () => void;
}

export const PreviewImageDialog: FC<PreviewImageDialog> = (props) => {
  const { open, url, onClose } = props;
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(open);
  }, [open]);

  const handleImageLoad = () => {
    setTimeout(() => setLoading(false), 1000);
  };

  return (
    <Dialog open={open} maxWidth={false}>
      <DialogContentWrapper>
        <DialogTitle sx={{ cursor: 'default' }}>
          Preview Image
          <CloseDialogButton onClick={onClose} />
        </DialogTitle>
        <DialogContent sx={{ width: '660px', padding: '40px 20px 0 20px' }}>
          <Card>
            <CardContent style={{ padding: 0, width: '100%' }}>
              {loading && (
                <Box sx={{ display: 'flex', height: '320px', width: '100%' }}>
                  <Box sx={{ display: 'flex', margin: 'auto', flexDirection: 'column' }}>
                    <LinearProgress sx={{ width: '120px', height: '6px', marginBottom: '6px' }} />
                    <Box sx={{ textAlign: 'center' }}>Loading image...</Box>
                  </Box>
                </Box>
              )}
              <img
                src={url}
                alt="Preview Image"
                onLoad={handleImageLoad}
                onError={handleImageLoad}
                style={{
                  display: loading ? 'hidden' : 'block',
                  width: loading ? '0' : '100%',
                  height: loading ? '0' : 'auto',
                  maxHeight: '600px'
                }}
              />
              <Hr />
              <ToolbarSection>
                <Button
                  variant="contained"
                  onClick={onClose}
                  sx={{ marginLeft: 'auto!important', marginRight: '16px' }}
                  disableElevation
                >
                  Ok
                </Button>
              </ToolbarSection>
            </CardContent>
          </Card>
        </DialogContent>
      </DialogContentWrapper>
    </Dialog>
  );
};
